export const CLINIC_WHATSAPP_NUMBER = "919096567419";
export const CLINIC_PHONE_DISPLAY = "+91 90965 67419";
export const CLINIC_EMAIL = "vishvesha.dhoble@gmail.com";
export const CLINIC_NAME = "Dr. Vishwa's Dental Hospital";
export const CLINIC_ADDRESS =
  "Shop no. S4, Flora Galaxia Apartment, New IMS Road, Bank Colony, Solapur";
export const CLINIC_HOURS = "10:00 AM – 09:00 PM";
export const INSTAGRAM_URL =
  "https://www.instagram.com/dr_vishwa_dental_hospital/";
export const MAP_EMBED_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3802.508563439369!2d75.90680991074923!3d17.626056283232746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc5d90071a32a4f%3A0x833dbcf19bce9899!2sDR.%20VISHWA'S%20DENTAL%20HOSPITAL!5e0!3m2!1sen!2sin!4v1787591407762!5m2!1sen!2sin";
export const MAP_DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=DR.%20VISHWA'S%20DENTAL%20HOSPITAL%2C%20Shop%20no.%20S4%2C%20Flora%20Galaxia%20Apartment%2C%20New%20IMS%20Road%2C%20Bank%20Colony%2C%20Solapur";
export const WHATSAPP_CHAT_URL = `https://wa.me/${CLINIC_WHATSAPP_NUMBER}`;

export const SERVICES = [
  {
    slug: "root-canal-treatment",
    icon: "Activity",
    title: "Root Canal Treatment",
    desc: "Painless single-visit root canals that save your natural tooth and relieve infection fast.",
  },
  {
    slug: "smile-design",
    icon: "Smile",
    title: "Smile Design",
    desc: "A digitally planned smile makeover crafted around your face, personality and goals.",
  },
  {
    slug: "teeth-whitening-cleaning",
    icon: "Sparkles",
    title: "Teeth Whitening & Cleaning",
    desc: "Gentle scaling, polishing and whitening that lift stains and refresh your smile.",
  },
  {
    slug: "veneers",
    icon: "Layers",
    title: "Veneers",
    desc: "Ultra-thin porcelain shells that correct chips, gaps and discolouration beautifully.",
  },
  {
    slug: "dental-filling",
    icon: "CircleDot",
    title: "Dental Filling",
    desc: "Tooth-coloured composite fillings that restore cavities invisibly and durably.",
  },
  {
    slug: "crowns-bridges",
    icon: "Crown",
    title: "Dental Crowns & Bridges",
    desc: "CAD/CAM-crafted crowns and bridges that fit precisely and look completely natural.",
  },
  {
    slug: "braces-aligners",
    icon: "Braces",
    title: "Dental Braces & Aligners",
    desc: "Metal, ceramic and clear aligner options to straighten teeth at any age.",
  },
  {
    slug: "dental-implant",
    icon: "Anchor",
    title: "Dental Implant",
    desc: "Permanent, natural-feeling replacements for missing teeth, planned with 3D imaging.",
  },
  {
    slug: "kids-dental-care",
    icon: "Baby",
    title: "Kids Dental Care",
    desc: "Friendly, fear-free dentistry for children — from first checkups to cavity care.",
  },
  {
    slug: "dentures",
    icon: "LayoutGrid",
    title: "Dentures",
    desc: "Comfortable, well-fitting complete and partial dentures that restore confident eating.",
  },
  {
    slug: "invisalign-aligners",
    icon: "ScanLine",
    title: "Invisalign Aligners",
    desc: "World-leading clear aligner therapy, nearly invisible and fully removable.",
  },
  {
    slug: "oral-surgical-care",
    icon: "Syringe",
    title: "Oral Surgical Care",
    desc: "Safe extractions, wisdom tooth removal and minor surgical procedures under expert care.",
  },
  {
    slug: "full-mouth-rehabilitation",
    icon: "HeartPulse",
    title: "Full Mouth Rehabilitation",
    desc: "Complete restoration of function and aesthetics for worn, damaged or missing dentition.",
  },
];

export const DOCTORS = [
  {
    name: "Dr. Vishvesha Dhoble",
    designation: "Cosmetic Dentist & CEO",
    desc: "Dr. Vishwa completed Bachelors of Dental Science from RGUHS, and have expertise in Smile Design, Root Canal with 11 years of experience. Registration no :- A-50409",
    photo: "/assets/doctor1.jpg",
  },
  {
    name: "Dr. Shrinivas Ambarkar",
    designation: "MDS Orthodontist",
    desc: "Specialist in Smile Design, Braces and Smile Makeovers with 28 years of experience.",
    photo: null,
  },
  {
    name: "Dr. Mithilesh Kotangale",
    designation: "Prosthodontist",
    desc: "Implant specialist with 20 years of experience.",
    photo: null,
  },
  {
    name: "Dr. Nilesh Birajdar",
    designation: "BDS, MDS Oral Surgeon",
    desc: "Consultant Oral Surgeon",
    photo: null,
  },
];

export const STORY_IMAGES = Array.from(
  { length: 28 },
  (_, i) => `/assets/s${i + 1}.jpg`
);

export const GALLERY_TAGS = [
  "Smile Makeover",
  "Whitening & Cleaning",
  "Braces & Aligners",
  "Implants & Crowns",
  "Kids Dentistry",
];

const STORY_ORDER = [1, 2, 3, 4, 5, 6, 28, 9, 10, 11, 12, 15, 16, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 7];

export const GALLERY_ITEMS = STORY_ORDER.map((n, i) => ({
  src: `/assets/s${n}.jpg`,
  tag: GALLERY_TAGS[i % GALLERY_TAGS.length],
  caseNo: n,
}));

export const LAB_IMAGES = [
  { src: "/assets/lab-logo.png", contain: true },
  { src: "/assets/lab1.jpg", contain: false },
  { src: "/assets/lab2.jpg", contain: false },
  { src: "/assets/lab3.jpg", contain: false },
];

export const TECH_ITEMS = [
  { code: "TECH 01", name: "Digital X-Ray", src: "/assets/tech-xray.jpg" },
  { code: "TECH 02", name: "Intra Oral Scanning", src: "/assets/tech-scan.jpg" },
  { code: "TECH 03", name: "Advanced CAD/CAM Restorations", src: "/assets/tech-cadcam.jpg" },
];

export const TIME_SLOTS = (() => {
  const slots = [];
  for (let h = 10; h < 21; h++) {
    for (const m of [0, 30]) {
      const hour12 = ((h + 11) % 12) + 1;
      const ampm = h < 12 ? "AM" : "PM";
      slots.push(
        `${String(hour12).padStart(2, "0")}:${m === 0 ? "00" : "30"} ${ampm}`
      );
    }
  }
  return slots;
})();
